<template>
  <m-popup
    v-model:visible="show"
    :close-on-overlay-click="false"
    content-class="feiyu-share-dialog--content"
    max-width="88%"
    :min-width="320"
    overlay-class="feiyu-share-dialog--overlay"
    position="center"
  >
    <div class="feiyu-share-dialog">
      <div v-if="title" class="feiyu-share-dialog--title">{{ title }}</div>
      <div class="feiyu-share-dialog--body">
        <slot>{{ content }}</slot>
      </div>
      <div v-if="cancel || confirm" class="feiyu-share-dialog--footer">
        <div
          v-if="cancel"
          class="feiyu-share-dialog--footer-cancel"
          :style="{ color: cancelColor }"
          @click="onCancelClick"
        >
          {{ cancelText }}
        </div>
        <div
          v-if="confirm"
          class="feiyu-share-dialog--footer-confirm"
          :style="{ color: confirmColor }"
          @click="onConfirmClick"
        >
          {{ confirmText }}
        </div>
      </div>
    </div>
  </m-popup>
</template>

<script lang="ts">
export default {
  emits: ["update:visible", "confirm", "cancel"],
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: "" },
    content: { type: String, default: "" },
    confirm: { type: Boolean, default: true },
    confirmText: { type: String, default: "确定" },
    confirmColor: { type: String, default: "#333333" },
    cancel: { type: Boolean, default: true },
    cancelText: { type: String, default: "取消" },
    cancelColor: { type: String, default: "#9b9b9b" },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  methods: {
    onCancelClick() {
      this.$emit("cancel");
      this.show = false;
    },
    onConfirmClick() {
      this.$emit("confirm");
      this.show = false;
    },
  },
};
</script>

<style lang="less">
.feiyu-share-dialog--overlay {
  background: rgba(0, 0, 0, 0.5);
}

.feiyu-share-dialog--content {
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
}

.feiyu-share-dialog {
  background-color: #ffffff;
}

.feiyu-share-dialog--title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  background-color: #f0f2f9;
  font-weight: 500;
  font-size: 18px;
}

.feiyu-share-dialog--body {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 24px;
  font-size: 16px;
}

.feiyu-share-dialog--title + .feiyu-share-dialog--body {
  min-height: 24px;
}

.feiyu-share-dialog--footer {
  display: flex;
  border-top: 1px solid #e4e6eb;
}

.feiyu-share-dialog--footer-confirm,
.feiyu-share-dialog--footer-cancel {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 50px;
  font-weight: 500;
  font-size: 15px;

  & + & {
    border-left: 1px solid #e4e6eb;
  }
}
</style>
